export const REQUEST_PLAN_SUBSCRIPTIONS = 'REQUEST_PLAN_SUBSCRIPTIONS';
export const RECEIVED_PLAN_SUBSCRIPTIONS = 'RECEIVED_PLAN_SUBSCRIPTIONS';
export const PLAN_SUBSCRIPTIONS_REQUEST_FAILED =
  'PLAN_SUBSCRIPTIONS_REQUEST_FAILED';

export const UPDATE_SELECTED_ORGS = 'UPDATE_SELECTED_ORGS';
export const ORGS_SELECT_NOT_COMPLETED = 'ORGS_SELECT_NOT_COMPLETED';
